import "./memo-root.scss"

export function MemoRoot({ children }: any) {
    return (
        <div className="memo-root">
            <i className="icon-message leading" /> {children}
        </div>
    )
}